

import { useQuery } from "@tanstack/react-query";
import type { StoreSubscriptionPaymentProofUrlResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreSubscriptionPaymentProofUrlQueryParams = {
  storeId: string;
  paymentId: string;
};

export function useStoreSubscriptionPaymentProofUrlQuery({
  storeId,
  paymentId,
}: UseStoreSubscriptionPaymentProofUrlQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.storeSubscriptionPaymentProofUrl(storeId, paymentId),
    queryFn: () =>
      apiJsonClient<StoreSubscriptionPaymentProofUrlResponse>(
        endpoints.admin.storeSubscriptionPaymentProofUrl(storeId, paymentId),
      ),
    enabled: storeId.length > 0 && paymentId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
